import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleNavigationPathDataService } from '../../../services/data-services/navigation-data-services';

@Component({
  selector: 'app-examiner-new',
  templateUrl: './examiner-new.component.html',
  styleUrls: ['./examiner-new.component.sass'],
})
export class ExaminerNewComponent implements OnInit {
  examReportId: string | undefined;

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: SimpleNavigationPathDataService
  ) {
    this.titleService.setTitle('Vizsgabiztos létrehozása');
    this.examReportId = this.route.snapshot.paramMap.get('id') ?? undefined;
  }

  ngOnInit(): void {}

  get navigateBackData(): string {
    return this.navigationService.navigateBackPath;
  }
  get navigateToData(): string {
    return this.navigationService.navigateToPath;
  }
}
